<template>
    <div class="task-item">
        <div class="left">
            <div class="icon">
                <img :src="icon" />
            </div>
            <div class="text">
                <div class="title">
                    <span>{{ title }}</span>
                    <img src="../../../../assets/img/icon-score.png" class="icon" />
                    <span class="number">+{{ score }}</span>
                </div>
                <div class="desc">{{ desc }}</div>
            </div>
        </div>
        <div class="right">
            <div v-if="taskStatus !== 3" class="button" @click="handleButtonClick">
                {{ taskButtonText }}
            </div>
            <div v-else class="status-text" @click="handleButtonClick">{{ taskButtonText }}</div>
        </div>
    </div>
</template>

<script>
import { TASK_STATUS_MAP } from '../../utils/const';
export default {
    props: {
        task: Object
    },
    computed: {
        icon() {
            return this.task.icon || '';
        },
        title() {
            return this.task.title || '';
        },
        desc() {
            return this.task.desc || '';
        },
        score() {
            return this.task.score || 0;
        },
        taskButtonText() {
            return this.task.taskButtonText || '';
        },
        taskStatus() {
            return this.task.taskStatus || 0;
        },
        redirectUrl() {
            return this.task.redirectUrl || '';
        },
        buttonVisible() {
            const status = TASK_STATUS_MAP[this.taskStatus] || '';
            return status === '未完成';
        }
    },
    methods: {
        handleButtonClick() {
            this.$emit('button-click', this.task);
        }
    }
};
</script>

<style lang="scss" scoped>
.task-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    line-height: 1.375;
    .left {
        display: flex;
        align-items: center;
        .icon {
            img {
                width: 30px;
                border-radius: 50%;
            }
        }
        .text {
            margin-left: 10px;
            .title {
                display: flex;
                align-items: center;
                span {
                    font-weight: bold;
                    font-size: 14px;
                }
                .icon {
                    transform: translateY(-2px);
                    margin-left: 7px;
                    width: 16px;
                    height: 16px;
                }
                .number {
                    transform: translateY(-2px);
                    font-size: 12px;
                    margin-left: 2px;
                    color: #ff5a5a;
                }
            }
            .desc {
                font-weight: bold;
                margin-top: 5px;
                color: #9faab5;
            }
        }
    }
    .right {
        flex: 0 0 72px;
        text-align: center;
        .status-text {
            font-weight: bold;
            color: #9faab5;
        }
        .button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: bold;
            color: #904e30;
            width: 70px;
            height: 28px;
            background: linear-gradient(90deg, #f4d583 0%, #f0bc53 100%);
            border-radius: 15px;
        }
    }
}
</style>